// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  ElevatorFaultMessage,
  ElevatorFaultMessageT,
  verifyElevatorFaultMessage,
} from "./elevator-fault-message";
import {
  EscalatorFaultMessage,
  EscalatorFaultMessageT,
  verifyEscalatorFaultMessage,
} from "./escalator-fault-message";
import { FaultContent, unionToFaultContent, unionListToFaultContent } from "./fault-content";

export class FaultMessage implements flatbuffers.IUnpackableObject<FaultMessageT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): FaultMessage {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsFaultMessage(bb: flatbuffers.ByteBuffer, obj?: FaultMessage): FaultMessage {
    return (obj || new FaultMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsFaultMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: FaultMessage,
  ): FaultMessage {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new FaultMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  faultType(): FaultContent {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : FaultContent.NONE;
  }

  fault<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  static startFaultMessage(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addFaultType(builder: flatbuffers.Builder, faultType: FaultContent) {
    builder.addFieldInt8(0, faultType, FaultContent.NONE);
  }

  static addFault(builder: flatbuffers.Builder, faultOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, faultOffset, 0);
  }

  static endFaultMessage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // fault
    return offset;
  }

  static createFaultMessage(
    builder: flatbuffers.Builder,
    faultType: FaultContent,
    faultOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    FaultMessage.startFaultMessage(builder);
    FaultMessage.addFaultType(builder, faultType);
    FaultMessage.addFault(builder, faultOffset);
    return FaultMessage.endFaultMessage(builder);
  }

  unpack(): FaultMessageT {
    return new FaultMessageT(
      this.faultType(),
      (() => {
        const temp = unionToFaultContent(this.faultType(), this.fault.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
    );
  }

  unpackTo(_o: FaultMessageT): void {
    _o.faultType = this.faultType();
    _o.fault = (() => {
      const temp = unionToFaultContent(this.faultType(), this.fault.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
  }

  unpackFields(...fields: string[]): FaultMessageT {
    const t = new FaultMessageT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("fault_type")) {
      t.faultType = this.faultType();
    }
    if (fieldSet.has("fault")) {
      t.fault = (() => {
        const temp = unionToFaultContent(this.faultType(), this.fault.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    return t;
  }
}

export class FaultMessageT implements flatbuffers.IGeneratedObject {
  constructor(
    public faultType: FaultContent = FaultContent.NONE,
    public fault: ElevatorFaultMessageT | EscalatorFaultMessageT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.fault === null || this.fault === undefined) {
      throw new Error('Required field "fault" is not set');
    }
    const fault = builder.createObjectOffset(this.fault);

    return FaultMessage.createFaultMessage(builder, this.faultType, fault);
  }

  clone(): FaultMessageT {
    const obj = new FaultMessageT();
    obj.faultType = this.faultType;
    obj.fault =
      this.fault !== null && typeof (this.fault as any).clone === "function"
        ? (this.fault as any).clone()
        : this.fault;
    return obj;
  }

  equals(other: FaultMessageT): boolean {
    if (this.faultType !== other.faultType) return false;
    if (this.fault !== null && other.fault !== null) {
      if (typeof (this.fault as any).equals === "function") {
        if (!(this.fault as any).equals(other.fault)) return false;
      } else if (this.fault !== other.fault) return false;
    } else if (this.fault !== other.fault) return false;
    return true;
  }
}

export function verifyFaultMessage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkUnionConsistency(tablePos, 4, 6, "fault");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 4);
        switch (uType) {
          case 1: // ElevatorFaultMessage
            {
              const o = verifier.readInt32(pos);
              verifyElevatorFaultMessage(verifier, pos + o);
            }
            break;
          case 2: // EscalatorFaultMessage
            {
              const o = verifier.readInt32(pos);
              verifyEscalatorFaultMessage(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 6, "fault");
  } finally {
    verifier.popDepth();
  }
}
